import React from 'react';
import './Input.css';

export function Input({
  label,
  error,
  hint,
  icon: Icon,
  className = '',
  id,
  ...props
}) {
  const inputId = id || (label ? `input-${label.replace(/\s/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ui-input-wrap ${error ? 'ui-input-wrap--error' : ''} ${className}`}>
      {label && <label className="ui-input__label" htmlFor={inputId}>{label}</label>}
      <div className="ui-input__container">
        {Icon && <Icon size={16} className="ui-input__icon" />}
        <input
          className={`ui-input ${Icon ? 'ui-input--with-icon' : ''}`}
          id={inputId}
          {...props}
        />
      </div>
      {(error || hint) && (
        <span className={`ui-input__hint ${error ? 'ui-input__hint--error' : ''}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
}
